import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { School, Note } from '../../models'
import useDistricts from '../../hooks/useDistricts'
import classes from './SchoolNoteSchoolForm.module.sass'
import NoteField from './NoteField'
import Button from '../Button'
import SchoolView from './SchoolView'
import SchoolEdit from './SchoolEdit'
import NotesTable from './NotesTable'
import { toast } from 'react-toastify'

const MODES = {
  EDIT: 'edit',
  VIEW: 'view',
}

const SchoolNoteSchoolForm = ({ schoolId }) => {
  const [school, setSchool] = useState()
  const districts = useDistricts()
  const [mode, setMode] = useState(MODES.VIEW)
  const [_, setCount] = useState(0)

  useEffect(() => {
    School
      .merge({ notes: Note.order('createdAt') })
      .includes('notes')
      .find(schoolId)
      .then((res) => setSchool(res.data))
  }, [schoolId])

  const handleSubmit = (event) => {
    if (mode === MODES.VIEW) {
      setMode(MODES.EDIT)
      return
    }
    event.preventDefault()

    school
      .save({ with: ['district'] })
      .then((res) => {
        if (!res) return

        setMode(MODES.VIEW)
        toast.success('Successfully saved')
      })
  }

  const addNewNote = (note) => {
    setSchool((prev) => {
      prev.notes = [...prev.notes, note]

      return prev.dup()
    })
  }

  const onChange = (event) => {
    setSchool((prev) => {
      prev[event.target.name] = event.target.value

      setCount((prevCount) => prevCount + 1)
      return prev
    })
  }

  const toggleMode = () => {
    if (mode === MODES.VIEW) setMode(MODES.EDIT)
    else setMode(MODES.VIEW)
  }

  if (!school) return null

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.linkBtnContainer}>
        <Button classes={classes.linkBtn} onClick={handleSubmit}>
          {mode === MODES.VIEW ? 'Edit School' : 'Stop Editing and Save'}
        </Button>
      </div>
      <form onSubmit={handleSubmit}>
        {mode === MODES.VIEW ? (
          <SchoolView school={school} />
        ) : (
          <SchoolEdit school={school} districts={districts} onChange={onChange} />
        )}
      </form>
      <NotesTable school={school} notes={school.notes} addNote={addNewNote} />
    </MuiPickersUtilsProvider>
  )
}

SchoolNoteSchoolForm.propTypes = {
  schoolId: PropTypes.number.isRequired,
}

export default SchoolNoteSchoolForm
